import { DropdownIcon } from "app/components/Icons";
import PlusIcon from "app/components/Icons/PlusIcon";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import clsx from "clsx";
import React from "react";
import { useAddTicketLogic } from "../../../Tickets/components/useAddTicketLogic";

interface AddTaskButtonProps {
  groupId: string;
  dropzoneRef: React.RefObject<HTMLDivElement>;
  showAddTaskIcon: boolean;
  subGroupId?: string;
}

const AddTaskButton: React.FC<AddTaskButtonProps> = ({
  groupId,
  dropzoneRef,
  showAddTaskIcon,
  subGroupId,
}) => {
  const [open, setOpen] = React.useState(false);

  const scrollToTop = () => {
    dropzoneRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  };
  const { defaultTypeName, handleTicketTask, handleTicketType, selectedType } =
    useAddTicketLogic(groupId, subGroupId, scrollToTop);

  return (
    <button
      className={clsx(
        " flex items-center group gap-1 h-8 ",
        showAddTaskIcon ? " hidden " : "",
      )}
    >
      <PlusIcon color="#5A8DF1" />
      <div className="flex flex-row items-center group-hover:bg-white group-hover:border group-hover:border-gray-200  rounded">
        <button
          className="hover:bg-gray-200 text-sm font-medium text-primary"
          onClick={(e) => {
            e.stopPropagation();
            handleTicketTask();
          }}
        >
          Add {defaultTypeName}
        </button>
        <CommonTicketTypeSelection
          setOpen={() => {
            setOpen(!open);
          }}
          trigger={
            <button
              className={clsx(
                "group-hover:visible hover:bg-gray-200 border-l border-gray-100 justify-center items-center size-[20px]",
                open ? "rotate-180" : "rotate-270",
              )}
            >
              <DropdownIcon size={20} />
            </button>
          }
          value={selectedType}
          setValue={(data) => {
            handleTicketType(data?._id);
          }}
          isHeader="TICKET TYPES"
          className="!w-[237px]"
          showDefault
        />
      </div>
    </button>
  );
};

export default AddTaskButton;
